import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { AuthService } from '../../services/auth/auth.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-about-innovadoc-ia',
    templateUrl: './about-innovadoc-ia.component.html',
    styleUrls: ['./about-innovadoc-ia.component.scss'],
    standalone: false
})

export class AboutInnovadocIaComponent {
  isAuthenticated$: Observable<boolean>;

  constructor(
    private router: Router,
    private titleService: Title,
    private metaService: Meta,
    private authService: AuthService
  ) {
    this.titleService.setTitle('Sobre Innovadoc IA | Inteligencia Artificial y Automatización');
    this.metaService.updateTag({ name: 'description', content: 'Conoce Innovadoc IA: expertos en inteligencia artificial, automatización y transformación digital para empresas.' });
    this.metaService.updateTag({ name: 'robots', content: 'index, follow' });
    this.isAuthenticated$ = this.authService.isAuthenticated$;
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  goToSignup() {
    this.router.navigate(['/signup']);
  }
}
